var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('standard-combobox',{attrs:{"label":_vm.$t('label.current-location'),"items":_vm.items,"is-read-only":_vm.isReadOnly,"disabled":_vm.isReadOnly},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }